module.exports = __webpack_public_path__ + "img/cdrcwewm_code.d68618fc.png";